<template id="home-dashboard">
  <section style="height: 87vh; overflow: auto">
    <div class="card-deck m-2">
      <template v-if="call">
        <dc-vizlet v-for="(r,index) in homeData" v-bind:key="index" :dc-viz="r"></dc-vizlet>
      </template>
    </div>


  </section>
</template>
<script>

//import axios from 'axios'

// import {bus} from "@/bus"
import dcVizlet from '@/components/dc-vizlet'

export default {
  name: 'home-dashboard',
  components: {dcVizlet},

  data: () => ({

    call: null,
    res: '',
    levelOnePeriodData: [],
    annotations: [],
    filterPeriodLevel1: '',
    filterPeriodLevel2: 'quarterly',
    //filterPeriodLevel2: 'weekly',
    //filterPeriodLevel2: 'monthly',
    searching: false,
    annotationTitle: '',
    reportTitle: '',
    dataSqlId: '',
    viztypeClassName: '',
    homeData: {},
    allSummaryData: null
  }),
  computed: {},
  beforeMount() {
    console.log("before mount called",this.$store.state.deviceType)
    if(this.$store.state.deviceType==='Mobile'){
      // Get mobile path - user config overrides role config
      const mobilePath = this.$store.state.user.deviceLandingPageConfig?.mobile ??
          this.$store.state.userRoleRestriction.deviceLandingPageConfig?.mobile;
      this.$router.push(mobilePath);
      this.handleFirstVisitReload()
      return;
    }
    if (this.$store.state.user.enforcePasswordReset) {
      this.$router.push('/change-password');
      return;
    }
    const { homeDashboardMenuId } = this.$store.state.user;
    if (!homeDashboardMenuId) {
      //Check if the role home dashboard menu id is pointed to different URL
      if( this.$store.state.user.userRoleRestriction.homeDashboardMenuId && this.$store.state.user.userRoleRestriction.homeDashboardMenuId.includes('/')){
        console.log("router push home")
        this.$router.push(this.$store.state.user.userRoleRestriction.homeDashboardMenuId)
      }
    } else {
      //Check if the role home dashboard menu id is pointed to different URL
      if( this.$store.state.user.homeDashboardMenuId && this.$store.state.user.homeDashboardMenuId.includes('/')){
        console.log("router push home")
        this.$router.push(this.$store.state.user.homeDashboardMenuId)
      }
    }

  },

  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  created () {
    this.fetchData()
  },
  mounted() {
    this.handleFirstVisitReload();
  },
  methods: {
    handleFirstVisitReload() {
      const hasReloaded = localStorage.getItem('hasReloaded');

      if (!hasReloaded) {
        localStorage.setItem('hasReloaded', 'true');

        // Force a hard reload (avoids caching issues)
        window.location.reload(); // `true` forces a cache bypass (deprecated in some browsers)

        // Alternative (modern approach):
        // window.location.href = window.location.href;
      }
    },
    fetchData: function () {
      let l = setInterval(() => {
        if (this.$store.state.stateLoaded) {
          this.loadHomeConfig()
          this.listenToRouter()
          clearInterval(l)

        } else {
          console.log('state is not loaded...')
        }
      }, 300)
    },
    periodLOne: function () {
      this.filterPeriodLevel2 = 'quarterly'
      //this.filterPeriodLevel2 = 'weekly'
      //this.filterPeriodLevel2 = 'monthly'
      this.dcSummaryCharts()
      //  this.updateReportData()
    },
    periodLTwo: function () {
      this.dcSummaryCharts()
    },
    loadHomeConfig: function () {
      this.$store.dispatch('loadState').then(() => {
        this.configData = this.$store.state.fwConfigScreenElement
        //let submenuParam = this.$route.params.submenuId
        const { homeDashboardMenuId } = this.$store.state.user;
        let submenuParam =homeDashboardMenuId?this.$store.state.user.homeDashboardMenuId: this.$store.state.user.userRoleRestriction.homeDashboardMenuId
        // Extract just the last part of the path
        if (submenuParam) {
          submenuParam = submenuParam.split('/').pop();
        }
        console.log('Route Param', submenuParam)
        this.homeData = this.configData.filter(r => r.menuId === submenuParam)
        console.log('All Home config data are:', this.homeData)

        let allViztypeData = this.$store.state.vizType
        let viztypeDataList = allViztypeData.filter((t) => t.viztypeId === 'V77')
        if (viztypeDataList.length > 0) {
          let viztypeData = viztypeDataList[0]
          if (this.homeData.length > 0) {

            this.dataSqlId = this.homeData[0].datasqlId
            this.viztypeClassName = viztypeData.viztypeClassName

            //this.loadSummary()
            this.$commonFn.crossfilterDatafetch(this.dataSqlId, this.viztypeClassName).then(() => {
              this.call = true
            })

          }
        }
      })

    },
    listenToRouter: function() {
      let $this = this;
      this.$router.afterEach(function(to, from) {
        console.log(`router moved from ${from.path} to ${to.path}`);

        // Only load config if we're still on the home route
        if ($this.$route.name === 'home' || $this.$route.name === 'home-m-s') {
          console.log("home route")
          setTimeout(() => {
            $this.loadHomeConfig();
          }, 300);
        }
      });
    }
  }
}
</script>
